import { getToken } from "helpers";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { environment } from "environment";
import { BaseQueryResult } from "@reduxjs/toolkit/dist/query/baseQueryTypes";

interface Notification {
  notification_source: number;
  notification_type: number;
  tags: number[];
  notification: string;
  notification_for: { administrators: string[]; companies: string[] }[];
}

interface ResNotification {
  notification_id: string | number;
  notification_source: string | number;
  notification_type: string | number;
  author: {
    administrator_id: string | number;
    type_id: string | number;
    name: string | number;
  };
  notification_tags: Array<string | number>;
  notification: string;
  is_read: boolean;
  created_at: any;
}

// Define a service using a base URL and expected endpoints
export const notificationApi = createApi({
  reducerPath: "notificationApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${environment.dev.baseUrl}/auth/user/notification`,
    prepareHeaders: (headers) => {
      headers.set("authorization-token", getToken() || "");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    createNotification: builder.mutation<unknown, Notification>({
      query: ({ notification_source, notification_type, tags, notification, notification_for }) => ({
        url: "",
        method: "PUT",
        body: {
          notification_source,
          notification_type,
          tags,
          notification,
          notification_for,
        },
      }),
      transformErrorResponse: (error: any) => error.data.apierror,
    }),

    getNotifications: builder.query<ResNotification[], { is_read?: boolean }>({
      query: ({ is_read }) => ({
        url: "list",
        params: {
          is_read,
        },
      }),
      transformResponse: (response: BaseQueryResult<any>) => response.notifications,
      transformErrorResponse: (error: any) => error.data.apierror,
    }),

    markAsReadNotification: builder.mutation<unknown | any, number>({
      query: (notification_id) => ({
        url: "mark-as-read",
        method: "POST",
        body: {
          notification_id,
        },
      }),
      transformErrorResponse: (error: any) => error.data.apierror,
    }),
  }),
});

// Export hooks for usage in functional components, which are auto-generated based on the defined endpoints
export const {
  useCreateNotificationMutation,
  useGetNotificationsQuery,
  useLazyGetNotificationsQuery,
  useMarkAsReadNotificationMutation,
} = notificationApi;
